import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "spinner"]
  static values = { delay: { type: Number, default: 300 } }
  
  connect() {
    this.timeout = null
    
    // Listen for turbo:submit-start to show loading state
    this.element.addEventListener("turbo:submit-start", this.showLoading.bind(this))
    this.element.addEventListener("turbo:submit-end", this.hideLoading.bind(this))
    
    // Restore cursor position after turbo frame update
    if (this.hasInputTarget && this.inputTarget.dataset.cursorPosition) {
      const position = parseInt(this.inputTarget.dataset.cursorPosition)
      const previousValue = this.inputTarget.dataset.previousValue
      
      // Only restore if the value hasn't changed significantly
      if (this.inputTarget.value === previousValue) {
        this.inputTarget.setSelectionRange(position, position)
        this.inputTarget.focus()
      }
      
      // Clean up data attributes
      delete this.inputTarget.dataset.cursorPosition
      delete this.inputTarget.dataset.previousValue
    }
  }
  
  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.element.removeEventListener("turbo:submit-start", this.showLoading.bind(this))
    this.element.removeEventListener("turbo:submit-end", this.hideLoading.bind(this))
  }
  
  search(event) {
    // Clear any existing timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    
    // Store the cursor position
    const cursorPosition = this.inputTarget.selectionStart
    const inputValue = this.inputTarget.value
    
    // Set a new timeout to debounce the search
    this.timeout = setTimeout(() => {
      // Store cursor position in data attribute before submit
      this.inputTarget.dataset.cursorPosition = cursorPosition
      this.inputTarget.dataset.previousValue = inputValue
      this.element.requestSubmit()
    }, this.delayValue)
  }
  
  clear(event) {
    event.preventDefault()
    this.inputTarget.value = ""
    this.element.requestSubmit()
  }
  
  showLoading() {
    // Add a subtle loading indicator to the input
    this.inputTarget.classList.add("animate-pulse")
  }
  
  hideLoading() {
    // Remove loading indicator
    this.inputTarget.classList.remove("animate-pulse")
  }
}